import metadataReducer, { defaultState, type MetadataState } from "./metadataReducer";

export { defaultState, type MetadataState };
export default metadataReducer;
